import React, { } from "react";
import { Button, Modal } from "antd";
import { useDispatch } from "react-redux";
import InsightsDetails from "../ReportBuilder/Insights/InsightsDetails";
import { CloseOutlined } from "@ant-design/icons";
import { setVisibleInsightsModal } from "../../store/components/Reports.slice";
import CountryLanguages from "../General/CountryLanguages"
import useLanguages from "../../hooks/useLanguages"

function InsightsDetailsModal({
    data
}) {
    const dispatch = useDispatch();

    const {
        value,
        setLanguage,
        list
    } = useLanguages();

    const onClose = () => {
        dispatch(setVisibleInsightsModal({
            data: null,
            visible: false
        }));
    }
    return (
        <Modal
            width={700}
            height={500}
            centered
            className="report--insights"
            visible={data.visible}
            maskClosable={false}
            closable={false}
            title={(
                <div className="d-flex gap-1 align-items-center justify-content-between">
                    <div>
                        <span className="report--insights--details--title">{data.data.categoryName}</span>
                        <span className="report--insights--details--subtitle with-bottom-borderleft">{data.data.item}</span>
                    </div>
                    <div className="d-flex align-items-center justify-content-end">
                        <CountryLanguages
                            list={list}
                            selectProps={{
                                style: { width: 150 },
                                value,
                                onChange: (e) => {
                                    setLanguage(e);
                                }
                            }}
                        />
                        <Button
                            icon={<CloseOutlined style={{ fontSize: "12px" }} />}
                            type="text"
                            onClick={onClose}
                        />
                    </div>
                </div>
            )}
            footer={null}
            onCancel={onClose}
        >
            <div className="d-flex-col gap-1 report--insights--content">
                <InsightsDetails data={data.data} language={value} />
            </div>
        </Modal>
    );
}

export default InsightsDetailsModal;
